import { ISaveUsuarioTableSchemeUseCase } from "../../../presentation/useCases/update/save_usuario_table_scheme_use_case";
import { ICommonsRepository } from "../../repositories/commons_repository";

/**
 * SaveUsuarioTableSchemeUseCase
 */

export class SaveUsuarioTableSchemeUseCase implements ISaveUsuarioTableSchemeUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async saveUsuarioTableScheme(
    idUsuario: number,
    scheme: string,
  ): Promise<void> {
    await this.repository.saveUsuarioTableScheme(idUsuario, scheme);
  }
}
